import { z } from 'zod';

export const fieldTypeSchema = z.enum([
  'text',
  'email',
  'date',
  'number',
  'checkbox',
  'select',
  'textarea',
  'phone',
  'address',
  'party',
  'currency',
  'percentage',
  'url',
  'multiselect',
]);

export const screenTypeSchema = z.enum(['standard', 'signatory', 'dynamic']);

export const templateFieldSchema = z.object({
  name: z.string().min(1),
  label: z.string().min(1),
  type: fieldTypeSchema,
  required: z.boolean().default(false),
  placeholder: z.string().nullable().optional(),
  helpText: z.string().nullable().optional(),
  options: z.array(z.string()).default([]),
  order: z.number().int().min(0),
  aiSuggestionEnabled: z.boolean().default(false),
  aiSuggestionKey: z.string().nullable().optional(),
  uilmHelpTextKey: z.string().nullable().optional(),
  uilmLabelKey: z.string().nullable().optional(),
  uilmOptionsKeys: z.array(z.string()).default([]),
  uilmPlaceholderKey: z.string().nullable().optional(),
  conditions: z.any().nullable().optional(),
});

export const templateScreenSchema = z.object({
  title: z.string().min(1),
  description: z.string().nullable().optional(),
  order: z.number().int().min(0),
  type: screenTypeSchema.default('standard'),
  aiPrompt: z.string().nullable().optional(),
  aiOutputSchema: z.any().nullable().optional(),
  dynamicMaxFields: z.number().int().nullable().optional(),
  dynamicPrompt: z.string().nullable().optional(),
  signatoryConfig: z.any().nullable().optional(),
  uilmDescriptionKey: z.string().nullable().optional(),
  uilmTitleKey: z.string().nullable().optional(),
  enableApplyStandards: z.boolean().default(false),
  conditions: z.any().nullable().optional(),
  fields: z.array(templateFieldSchema).default([]),
});

export const templateDataSchema = z.object({
  slug: z
    .string()
    .min(1)
    .regex(/^[a-z0-9-]+$/, 'Slug must be lowercase alphanumeric with hyphens'),
  title: z.string().min(1),
  description: z.string().nullable().optional(),
  icon: z.string().nullable().optional(),
  available: z.boolean().default(false),
  popular: z.boolean().default(false),
  href: z.string().nullable().optional(),
  keywords: z.array(z.string()).default([]).optional(),
  estimatedMinutes: z.number().int().nullable().optional(),
  systemPrompt: z.string().nullable().optional(),
  systemPromptRole: z.string().nullable().optional(),
  uilmDescriptionKey: z.string().nullable().optional(),
  uilmTitleKey: z.string().nullable().optional(),
  screens: z.array(templateScreenSchema).default([]),
});

export const templateExportSchema = z.object({
  version: z.literal('1.0'),
  exportedAt: z.string().datetime(),
  template: templateDataSchema,
});

export type FieldType = z.infer<typeof fieldTypeSchema>;
export type ScreenType = z.infer<typeof screenTypeSchema>;
export type TemplateFieldData = z.infer<typeof templateFieldSchema>;
export type TemplateScreenData = z.infer<typeof templateScreenSchema>;
export type TemplateData = z.infer<typeof templateDataSchema>;
export type TemplateExport = z.infer<typeof templateExportSchema>;
